export class ErrorRefAmbiguous extends Error {}